import { Injector } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { getForwarderByPermission, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { AirwaysExpenseService } from '../../service/airways-expense.service';
import { CommonService } from '../../service/common.service';

@Component({
  selector: 'laas-airways-expense-setting-add',
  templateUrl: './airways-expense-setting-add.component.html',
  styleUrls: ['./airways-expense-setting-add.component.scss']
})
export class AirwaysExpenseSettingAddComponent extends SessionBaseComponent implements OnInit {

  readonly permissionCode = PermissionConstants.ViewAirwaysExpenseSetting;
  readonly permissionCodeForCreate = PermissionConstants.CreateAirwaysExpense;
  currentLang: string = this.laasSetting.language;
  isSearchFormOpen: boolean;

  //form
  addForm: FormGroup;
  airwaysExpense: any;
  submitted: boolean;

  //options
  forwarderOptions: any[];
  feeTypeOptions: any[];
  currencyOptions: any[];
  statusOptions: any[];
  countryOptions: any[];
  iataAreaOptions: any[];

  constructor(
    injector: Injector,
    private fb: FormBuilder,
    private commonDataService: CommonDataService,
    private commonService: CommonService,
    private dropdownOptionsService: DropdownOptionsService,
    private airwaysExpenseService: AirwaysExpenseService
  ) {
    super(injector);
    this.isSearchFormOpen = true;
    this.submitted = false;

    //options
    this.forwarderOptions = [];
    this.feeTypeOptions = [];
    this.currencyOptions = [];
    this.statusOptions = [];
    this.countryOptions = [];
    this.iataAreaOptions = [];

    this.airwaysExpense = {
      facility: this.laasSetting.facility,
      forwarder: '',
      status: '1',
      feeType: '',
      currency: '',
      amount: null,
      fromCountry: '',
      toIataArea: '',
      remark: null,
      isActivated: '1',
      startDtTimeZone: '',
      endDtTimeZone: '',
      updateUser: ''
    };

    this.addForm = this.fb.group({
      facility: this.laasSetting.facility,
      forwarder: ['', Validators.required],
      feeType: ['', Validators.required],
      currency: '',
      amount: [null, Validators.required],
      fromCountry: ['', Validators.required],
      toIataArea: ['', Validators.required],
      remark: null,
      isActivated: '1',
      startDtTimeZone: ['', Validators.required],
      endDtTimeZone: ['', Validators.required],
      updateUser: ''
    });
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.dropdownOptionsService.getForwarderOptions().subscribe({
      next: (options: any[]) => {
        this.forwarderOptions = options.filter((x: any) => {
          return (this.userProfile.userType === UserType.SuperAdmin.toString() ||
            this.userProfile.userType === UserType.Shipping.toString() ||
            getForwarderByPermission(this.userProfile, this.permissionCode).includes(x.optionCode));
        }).map(x => ({ label: x.optionDesc, value: x.optionCode }));
        this.translateService.get('Common.Message.ChooseOption')
        .subscribe({
          next: msg => {
            this.forwarderOptions.unshift({
              label: msg,
              value: ''
            });
          }
        });

      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'RFQStatus').subscribe({
      next: result => {
        this.statusOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
        this.translateService.get('Common.Message.ChooseOption')
          .subscribe({
            next: msg => {
              this.statusOptions.unshift({
                label: msg,
                value: ''
              });
            }
          });

      }
    });

    this.commonService.getFeeType('Airways').subscribe({
      next: result => {
        this.feeTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.feeTypeCode}-${x.feeTypeName}`,
            value: x.feeTypeCode,
          };
        });
        this.translateService.get('Common.Message.ChooseOption')
          .subscribe({
            next: msg => {
              this.feeTypeOptions.unshift({
                label: msg,
                value: ''
              });
            }
          });

      }
    });

    this.commonService.getCurrencyOptions().subscribe({
      next: result => {
        this.currencyOptions = [...result].map((x: any) => {
          return {
            label: `${x.currency_code}-${x.currency_name}`,
            value: x.currency_code,
          };
        });
        this.translateService.get('Common.Message.ChooseOption')
          .subscribe({
            next: msg => {
              this.currencyOptions.unshift({
                label: msg,
                value: ''
              });

            }
          });

      }
    });

    this.dropdownOptionsService.getVCountryOptions().subscribe({
      next: result => {
        this.countryOptions = [...result].map((x: any) => {
          return {
            label: x.countryName,
            value: x.countryCode,
          };
        });
        this.translateService.get('Common.Message.ChooseOption')
          .subscribe({
            next: msg => {
              this.countryOptions.unshift({
                label: msg,
                value: ''
              });
            }
          });

      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'IATAArea').subscribe({
      next: result => {
        this.iataAreaOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
        this.translateService.get('Common.Message.ChooseOption')
          .subscribe({
            next: msg => {

              this.iataAreaOptions.unshift({
                label: msg,
                value: ''
              });

            }
          });

      }
    });

    //rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.permissionCodeForCreate);
    if (!canInPage) {
      //go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }
  }

  saveBtn(event: any): void {
    this.submitted = true;
    if (this.addForm.invalid) {
      this.translateService.get('AirwaysExpenseSetting.Alert.CheckRequiredFields')
          .subscribe({
            next: msg => {
              this.toastService.warn(msg);
            }
          });

      return;
    }
    if (this.airwaysExpense.startDtTimeZone > this.airwaysExpense.endDtTimeZone) {
      this.translateService.get('AirwaysExpenseSetting.Alert.CheckDate')
          .subscribe({
            next: msg => {
              this.toastService.warn(msg);
            }
          });
      return;
    }

    //DateTime convert
    this.airwaysExpense.startDt = isNullOrEmpty(this.airwaysExpense.startDtTimeZone) ? null : new Date(this.airwaysExpense.startDtTimeZone).toISOString();
    this.airwaysExpense.endDt = isNullOrEmpty(this.airwaysExpense.endDtTimeZone) ? null : new Date(this.airwaysExpense.endDtTimeZone).toISOString();
    this.airwaysExpense.updateUser = this.userProfile.userName;
    this.airwaysExpense.createUser = this.userProfile.userName;
    this.airwaysExpense.facility = this.laasSetting.facility;

    this.airwaysExpenseService.addAirwaysExpense(this.airwaysExpense).subscribe({
      next: result => {
        this.translateService.get('Common.Message.SuccessSave')
          .subscribe({
            next: msg => {
              this.toastService.success(msg);
              this.routeStateService.navigateTo('/Setting/AirwaysExpenseSetting', result);
            }
          });
      },
      error: err => {
        this.toastErrorMessage(err.error);
      }
    });
  }

  goToLastPage(): void {
    this.routeStateService.loadPrevious();
  }

  // convenience getter for easy access to form fields
  get f() { return this.addForm.controls; }
}
